import { Grid, styled } from "@mui/material";

const ContainerGridBar = styled(Grid)(() => ({
    paddingTop: "2.1rem",
    position: "sticky",
    top: "max(7vh, 50px)",
    height: "fit-content"
}));

export default ContainerGridBar